const role = {
  CUSTOMER: "customer",
};
export default role;
